import { Injectable } from "@angular/core";
import { createAction, props } from "@ngrx/store";
import { FeaturePermission, User } from "../../core/model/user.model";

@Injectable()
export class UserAction {
  static searchUser = createAction(
    "[User:Search] Search User",
    props<{ searchPattern: string }>()
  );

  static searchUserSuccess = createAction(
    "[User:Search] Search User Success",
    props<{ user: any }>()
  );

  static searchUserFail = createAction(
    "[User:Search] Search User Fail",
    props<{ error: any }>()
  );

  static getSelectedUserById = createAction(
    "[User] Get Selected User",
    props<{ userId: number }>()
  );

  static getSelectedUserByIdSuccess = createAction(
    "[User] Get Selected User Success",
    props<{ selectedUser: User }>()
  );

  static getTemplatesByUserId = createAction(
    "[Autoremind] Get Templates for AR3 user"
  );

  static getTemplatesByUserIdSuccess = createAction(
    "[Autoremind] Get Templates Success for AR3 user",
    props<{ payload: any }>()
  );

  static getTemplatesByUserIdFail = createAction(
    "[Autoremind] Get Templates Fail for AR3 user",
    props<{ error: any }>()
  );

  static getUserFeatures = createAction("[User: Features] Get User Features");

  static getUserFeaturesSuccess = createAction(
    "[User: Features] Get User Features Success",
    props<{ features: FeaturePermission[] }>()
  );

  static getUserFeaturesFail = createAction(
    "[User: Features] Get User Features Fail",
    props<{ error: any }>()
  );

  static setUserFeatures = createAction(
    "[User: Features] Set User Features",
    props<{ features: FeaturePermission[] }>()
  );

  static setUserHasChangeFlag = createAction(
    "[User: Features] Set User Has Changes Features Flag",
    props<{ value: boolean }>()
  );

  static getUserCustomFields = createAction("[Communications] Get UserCustomFields", props<{ userId: number }>());
  static getUserCustomFieldsSuccess = createAction("[Communications] Get UserCustomFields Success", props<{ userCustomFields: any }>());

}
